<template>
  <div class="container-fluid mb-0" :style="{ backgroundColor: bgColor }">
    <div class="line row">
      <!-- Left Column -->
      <div class="col-10">
        <AppLink strclass="navbar-brand" name="global-feed"></AppLink>
        <div class="title-row">
          <!-- <img src="../../assets/images/quote-img.png" class="quote-img" alt="Quote Icon" /> -->
          <h3 class="title-heading">
            <span
              :style="{ color: titleColor }"
              @click="navigateToHome"
              class="text-effect"
            >
              {{ title }}
            </span>
            <span class="title-medium">{{ updatedTitle }}</span>
          </h3>
        </div>
      </div>

      <!-- Right Column with Gap -->
      <div
        v-if="$route.name !== pageView.LOGINVIEW"
        class="col-2 d-flex justify-content-end align-items-center gap-3 mt-n2 px-1 pb-3"
      >
        <!-- UI Mode Toggle Button -->
     <div class="ui-toggle-wrapper" v-if="isDev" @click="toggleUI">
          <div
            class="ui-toggle"
            :class="{ active: uiToggle.showNewUI }"
          >
            <span class="ui-toggle-label">Switch to Classic UI</span>

            <div class="ui-toggle-track">
              <div class="ui-toggle-handle"></div>
            </div>
          </div>
        </div>


        <!-- Help Icon -->
        <div @click="redirectToPaveDoc" v-tooltip="supportToolTip">
          <img
            src="../../assets/icons/help.svg"
            alt="Help Icon"
            width="24"
            height="24"
            href="https://google.com"
          />
        </div>
        <!-- Profile Icon Dropdown -->
        <div v-if="!hideProfileIcon">
          <div class="dropdown">
            <button
              class="nav-link"
              type="button"
              id="dropdownMenuButton"
              aria-expanded="false"
            ></button>
            <ul
              class="dropdown-menu dropdown-menu-end"
              aria-labelledby="dropdownMenuButton"
            >
              <li class="logout-list">
                <a class="dropdown-item d-flex align-items-center" href="#">
                  <img
                    src="../../assets/icons/user.svg"
                    alt="User Logo"
                    class="me-1"
                  />
                  {{ userName }}
                </a>
              </li>
              <li class="logout-list">
                <hr class="dropdown-divider" />
              </li>
              <li class="logout-list" v-if="isUserSuperAdmin">
                <button
                  @click="manageRoles"
                  class="dropdown-item text-danger"
                  type="button"
                >
                  <img
                    src="../../assets/icons/users.svg"
                    alt="Manage Roles Icon"
                    class="manage-roles-icon"
                  />
                  User Management
                </button>
              </li>

              <li class="logout-list">
                <button
                  @click="manageDownloads"
                  class="dropdown-item text-danger"
                  type="button"
                >
                  <img
                    src="../../assets/icons/download.svg"
                    alt="Downloads Icon"
                    class="btn-delete"
                  />
                  Downloads
                </button>
              </li>

              <li class="logout-list">
                <button
                  type="button"
                  class="dropdown-item text-danger"
                  @click="trashView(projectType, userId)"
                >
                  <img
                    src="../../assets/icons/delete-red1.svg"
                    alt="Logout Icon"
                    class="btn-delete"
                  />
                  <span class="trash-icon-text"> Trash </span>
                </button>
              </li>
              <li class="logout-list">
                <button
                  @click="logout"
                  class="dropdown-item text-danger"
                  type="button"
                >
                  <img
                    src="../../assets/icons/logout.svg"
                    alt="Logout Icon"
                    class="logout-icon"
                  />
                  Log Off
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCookie, deleteCookie } from "@/store/cookie";
import { user, pageViews, role, type } from "@/utils/util";
import { makeAuthenticationRequest, getTitle } from "@/services/apiServices";
import { useAuthStore } from "../../store/auth.js";
import { redirect } from "@/utils/routerUtils.js";
import { getSessionItem, setSessionItem } from "@/store/session.js";
import ReportTemplate from "@/components/ReportTemplate.vue";
import { useSortStore, useTableColumnStore } from "../../store/sort.js";
import { toast } from "vue3-toastify";
import { useUiToggleStore } from "@/store/uiToggleStore";
import { watchEffect, onMounted } from 'vue'
export default {
  name: pageViews.HEADERVIEW,
  components: { ReportTemplate },
  data() {
    return {
      userId: getCookie(user.id),
      projectType: type.PROJECT,
      userName: getCookie(user.name),
      updatedTitle: "",
      isToggled: false,
      newView: "Try New View",
      trashViewToolTip: "Trash",
      supportToolTip: "User Guide",
      pageView: pageViews,
    };
  },
  computed: {
    hideProfileIcon() {
      return this.$route.meta.hideProfileIcon;
    },
    titleColor() {
      return this.$route.meta.titleColor;
    },
    bgColor() {
      return this.$route.meta.bgColor;
    },
    title() {
      return this.$route.meta.title;
    },
    isUserSuperAdmin() {
      return getCookie(user.role) === role.superadmin;
    },
    isNewViewRolledOut() {
      return this.$acclConfigs["rollout-new-view"];
    },
  },
  watch: {
    "$route.params.projectParamId": function (projectId) {
      this.updateTitle(projectId, this.$route.name);
    },
  },
  updated() {
    this.userName = getCookie(user.name);
  },
  routerParams() {
    return this.$route.params;
  },
  methods: {

 toggleUI() {
  const newValue = !this.uiToggle.showNewUI;
  this.uiToggle.setShowNewUI(newValue);
  console.log(newValue ? "Switched to New UI" : "Switched to Classic UI");
},


    redirectToPaveDoc() {
      window.open(
        window.acclConfigs.VUE_APP_SUPPORT_URL,
        "_blank" // <- This is what makes it open in a new window.
      );
      //window.location.href = window.acclConfigs.VUE_APP_SUPPORT_URL;
    },
    setValuesToStore(componentType, userId, requestId, convertedFileName) {
      setSessionItem("userId", userId);
      setSessionItem("componentType", componentType);
    },
    async trashView(type, userId) {
      console.log("Type:", type);
      this.setValuesToStore(type, userId);
      this.redirectView(pageViews.TRASHVIEW, {});
    },
    async redirectView(viewName, txnData) {
      redirect(
        type.PROJECT,
        this.$router,
        this.routerParams,
        viewName,
        txnData
      );
    },
    async logout() {
      const body = {
        userId: getCookie(user.id),
        authSource: getCookie(user.source),
      };
      let toastId = toast.loading("You are logging out", {
        autoClose: false,
        closeOnClick: false,
      });
      try {
        const response = await makeAuthenticationRequest(
          this.$acclConfigs,
          "/logout",
          body
        );
        if (response.status == 200) {
          // toast.success('You are logged out', {
          //     autoClose: 3000,
          // });

          toast.update(toastId, {
            render: "You have been logged out!",
            type: "success", // Change the toast type
            isLoading: false,
            autoClose: 2000, // Set a timeout for the updated toast
          });
          deleteCookie(user.id, user.name, user.source);
          this.clearJWTToken();
          this.sortStore.clearSortStates();
          this.tableStore.clearTableStates();
          this.$router.push({
            name: pageViews.LOGINVIEW,
          });
        }
      } catch (error) {
        console.log("Error message: Logout API Failed: ", error.message);
      }
    },
    toggle() {
      this.isToggled = !this.isToggled;
      if (this.isToggled) {
        this.newView = "Switch to Classic View";
        //window.location.href = 'https://google.com';
        this.$router.push({ name: pageViews.VIEW_404 });
      } else {
        this.newView = "Try New View";
        this.$router.push({ name: pageViews.ALLINONE_ACC_VIEW });
      }
    },
    navigateToHome() {
      if (this.isToggled) {
        this.isToggled = !this.isToggled;
        this.newView = "Try New View";
      }
      console.log(this.isToggled);
      this.$router.push({
        name: pageViews.ALLINONE_ACC_VIEW,
      });
    },
    async updateTitle(projectId, routeName) {
      if (
        ![
          pageViews.ALLINONE_ACC_VIEW,
          pageViews.DOWNLOADS_VIEW,
          pageViews.TRASHVIEW,
          pageViews.LOGINVIEW,
          pageViews.VIEW_404,
          pageViews.ERROR_VIEW,
          pageViews.MANAGE_USERS_VIEW,
        ].includes(routeName)
      ) {
        try {
          const response = await getTitle(
            this.$acclConfigs,
            projectId,
            this.userId,
            "project"
          );
          if (response.status == 200) {
            let prefix = "-";
            this.updatedTitle = prefix + " " + response.data.title;
          }
        } catch (error) {
          console.error("Error making api call - getTitle()", error);
        }
      } else {
        this.updatedTitle = "";
      }
    },
    async manageRoles() {
      this.$router.push({
        name: pageViews.MANAGE_USERS_VIEW,
      });
    },
    async manageDownloads() {
      this.$router.push({
        name: pageViews.DOWNLOADS_VIEW,
      });
    },
    setValuesToStore(componentType, userId) {
      setSessionItem("userId", userId);
      setSessionItem("componentType", componentType);
    },
  },
  setup() {
    const uiToggle = useUiToggleStore();

    // other setup stores you already have
    const sortStore = useSortStore();
    const authStore = useAuthStore();
    const tableStore = useTableColumnStore();

    const environment = window?.acclConfigs?.VUE_APP_ENVIRONMENT || "prod"; // default fallback

    const isDev = environment === "dev";


    onMounted(() => {
      // Apply background based on initial toggle state
      document.body.classList.toggle("old-ui-bg", !uiToggle.showNewUI);
    });

    watchEffect(() => {
      if (uiToggle.showNewUI) {
        document.body.classList.remove("old-ui-bg");
      } else {
        document.body.classList.add("old-ui-bg");
      }
    });

    function clearJWTToken() {
      authStore.clearToken();
    }
    return {
      clearJWTToken,
      sortStore,
      tableStore,
      uiToggle,
      isDev,
    };
  },
};
</script>

<style scoped>
.toggle-icon {
  cursor: pointer;
}

.toggle-icon-img {
  transition: color 0.3s;
}

.dropdown {
  position: relative;
  margin-left: -7px;
}

.manage-roles-icon {
  background-repeat: no-repeat;
  font-size: 12px;
  height: 20px;
  width: 26px;
  border: none;
}

.btn-delete {
  background-repeat: no-repeat;
  font-size: 12px;
  height: 20px;
  width: 26px;
  border: none;
}
.logout-icon {
  background-repeat: no-repeat;
  font-size: 12px;
  height: 20px;
  width: 26px;
  border: none;
  margin-left: -3px;
}
.dropdown-item:hover {
  color: black !important;
}
.dropdown-menu {
  display: none;
  position: absolute;
  /* top: 100%; */
  right: 0;
  min-width: 10rem;
}

.dropdown:hover .dropdown-menu {
  display: block;
}

.container-fluid h2 {
  font-family: system-ui;
}

.h3 {
  font-size: medium;
}

.text-effect {
  display: inline-block;
  transition: all 0.1s ease;
  margin-left: -5px;
}

.text-effect:hover {
  text-shadow: 0 0 0.1px #da6a26, 0 0 0.1px #da6a26, 0 0 0 #da6a26;
  cursor: pointer;
  color: #da6a26;
}

.logout-list {
  display: block;
}

.nav-link {
  background: url("../../assets/icons/profile.svg") no-repeat center;
  background-size: cover;
  font-size: 12px;
  margin-top: 3px;
  height: 20px;
  width: 26px;
  border: none;
  /* padding: 50%; */
  /* padding-right: 20%; */
}

.navbar-nav {
  margin-left: auto;
  /* This will align the nav items to the right */
}

nav {
  /* padding: 1em; */
  color: black;
  position: fixed;
  border-radius: 0.25rem;
  position: relative;
  /* padding: 0.5rem 1rem; */
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline;
  margin-right: 1em;
}

a {
  color: #050505;
  text-decoration: none;
  font-weight: bold;
}

.title-medium {
  font-size: x-large;
  margin-left: 0.7rem;
}

.manage-roles-icon {
  margin-left: -0.2rem;
}

/* === DEV MODE TOGGLE === */
.floating-toggle-container {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--surface);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  padding: 6px 10px;
  height: 40px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.floating-toggle-container:hover {
  background: var(--surface-hover);
}


.ui-toggle-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
}

/* Toggle container */
.ui-toggle {
  display: flex;
  align-items: center;
  white-space: nowrap;
  gap: 10px;
  margin-top: 5px;
  padding: 8px 14px;
  border-radius: 10px;
  border: 1px solid #000;
  transition: background 0.25s ease, border-color 0.25s ease;
  user-select: none;
}

/* Active look */
.ui-toggle.active {
  background: var(--primary-light);
  border-color: var(--primary);
}

/* Label */
.ui-toggle-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #000;
  transition: color 0.25s ease;
}

/* Toggle track */
.ui-toggle-track {
  width: 44px;
  height: 22px;
  background: #1d2856;
  border-radius: 20px;
  position: relative;
  transition: background 0.25s ease;
}

/* Active track */
.ui-toggle.active .ui-toggle-track {
  background: var(--primary);
}

/* Handle */
.ui-toggle-handle {
  width: 18px;
  height: 18px;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 3px;
  transition: transform 0.25s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.25);
}

/* Slide right when active */
.ui-toggle:not(.active) .ui-toggle-handle {
  transform: translateX(22px);
}


.slider {
  width: 18px;
  height: 18px;
  background: var(--surface);
  border-radius: 50%;
  position: absolute;
  left: 4px;
  top: 3px;
  transition: transform 0.25s ease;
}

.ui-toggle.active .slider {
  transform: translateX(24px);
}

.toggle-label {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.toggle-label input[type="checkbox"] {
  appearance: none;
  width: 32px;
  height: 18px;
  border-radius: 9px;
  background: var(--border-color);
  position: relative;
  transition: background 0.3s ease;
  cursor: pointer;
}

.toggle-label input[type="checkbox"]:checked {
  background: var(--primary);
}

.toggle-label input[type="checkbox"]::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.3s ease;
}

.toggle-label input[type="checkbox"]:checked::before {
  transform: translateX(14px);
}

.toggle-text {
  color: var(--text-secondary);
  font-size: 13px;
  user-select: none;
}
</style>
